import customAxios from "./axiosConfig";

const UserService = {
  retrieveCurrent: function (params) {
    var url = window.Urls['user-detail'](window.user_id);
    return customAxios.get(url, { params: params, useCache: true });
  },
  updateEmail: function (data) {
    var url = window.Urls["user_update_email"](window.user_id);
    return customAxios.post(url, data);
  },
  deleteAccount: function(data){
    var url = window.Urls["user_delete_account"](window.user_id);
    return customAxios.post(url, data);
  }
};

export default UserService;